import { createFileRoute } from "@tanstack/react-router";

import ConnectAi from "../pages/ConnectAi";
import { RequireAuth } from "../utils/RequireAuth";

export const Route = createFileRoute("/_shell/connect-ai")({
  component: ConnectAiRoute,
});

function ConnectAiRoute() {
  return (
    <RequireAuth require="chatbotAccess">
      <ConnectAi />
    </RequireAuth>
  );
}
